<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { baseUrl } from '@/core'

// Define Props ----------------------------------
const props = defineProps<{
  lang: string
}>()

// Define Emits ----------------------------------
const emit = defineEmits<{
  select: [id: number]
  animationend: [id: number]
}>()

// State -----------------------------------------
const { lang } = props
const currentId = ref(0)

// Getters ---------------------------------------

// Methods ---------------------------------------
function setActive(id: number) {
  currentId.value = id
  if (!document.querySelector('.menu.blink')) {
    update()
  }
}

function update() {
  const el = <HTMLImageElement>document.querySelector(`.menu.menu-${currentId.value}`)
  document.querySelectorAll('.menu.blink').forEach((e) => e.classList.remove('blink'))
  el?.offsetHeight
  el?.classList.add('blink')
}

// Events ----------------------------------------
function onAnimationend(id: number) {
  update()
  emit('animationend', id)
}

// Main Setup ------------------------------------
defineExpose({
  setActive,
  update,
})
// -----------------------------------------------
</script>

<template>
  <template v-for="n in 10">
    <img :class="['menu-bg', `menu-${n}`, `lang-${lang}`]" :src="baseUrl(`/images/home/${lang}/menu-${n}.png`)" />
    <img
      :class="['menu', `menu-${n}`, `lang-${lang}`]"
      :src="baseUrl(`/images/home/${lang}/menu-${n}a.png`)"
      @animationend="onAnimationend(n)"
      @click="emit('select', n)"
    />
  </template>
</template>

<style scoped>
/* ------------------------ */

/* ------------------------ */
.menu-bg {
  position: absolute;
  cursor: pointer;
}

.menu {
  position: absolute;
  cursor: pointer;
  opacity: 0;
}

/* ------------------------ */
/* prettier-ignore */
.menu-1 { left: 827px; top: 369px; }
/* prettier-ignore */
.menu-2 { left: 827px; top: 514px; }
/* prettier-ignore */
.menu-3 { left: 827px; top: 654px; }
/* prettier-ignore */
.menu-4 { left: 827px; top: 794px; }
/* prettier-ignore */
.menu-5 { left: 1368px; top: 369px; }
/* prettier-ignore */
.menu-6 { left: 1368px; top: 471px; }
/* prettier-ignore */
.menu-7 { left: 1368px; top: 555px; }
/* prettier-ignore */
.menu-8 { left: 1368px; top: 638px; }
/* prettier-ignore */
.menu-9 { left: 1368px; top: 723px; }
/* prettier-ignore */
.menu-10 { left: 1368px; top: 808px; }
/* ------------------------ */
/* prettier-ignore */
.menu-1.lang-en { left: 827px; top: 369px; }
/* prettier-ignore */
.menu-2.lang-en { left: 827px; top: 500px; }
/* prettier-ignore */
.menu-3.lang-en { left: 827px; top: 629px; }
/* prettier-ignore */
.menu-4.lang-en { left: 827px; top: 755px; }
/* prettier-ignore */
.menu-5.lang-en { left: 827px; top: 840px; }
/* prettier-ignore */
.menu-6.lang-en { left: 1368px; top: 369px; }
/* prettier-ignore */
.menu-7.lang-en { left: 1368px; top: 503px; }
/* prettier-ignore */
.menu-8.lang-en { left: 1368px; top: 594px; }
/* prettier-ignore */
.menu-9.lang-en { left: 1368px; top: 720px; }
/* prettier-ignore */
.menu-10.lang-en { left: 1368px; top: 837px; }
/* ------------------------ */

</style>
